import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  onAuthStateChanged,
  User,
} from "firebase/auth";
import { app } from "./firebase";

// Initialize Firebase Auth
const auth = getAuth(app);

// Sign in with email and password
export const login = async (email: string, password: string): Promise<User> => {
  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    return userCredential.user;
  } catch (error: any) {
    const errorMessage = error.message || "Failed to sign in";
    throw new Error(errorMessage);
  }
};

// Create a new user with email and password
export const signup = async (
  email: string,
  password: string
): Promise<User> => {
  try {
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );
    return userCredential.user;
  } catch (error: any) {
    const errorMessage = error.message || "Failed to create account";
    throw new Error(errorMessage);
  }
};

// Sign out the current user
export const logout = async (): Promise<void> => {
  try {
    await signOut(auth);
  } catch (error: any) {
    const errorMessage = error.message || "Failed to sign out";
    throw new Error(errorMessage);
  }
};

// Send a password reset email
export const resetPassword = async (email: string): Promise<void> => {
  try {
    await sendPasswordResetEmail(auth, email);
  } catch (error: any) {
    const errorMessage = error.message || "Failed to send password reset email";
    throw new Error(errorMessage);
  }
};

// Subscribe to auth state changes
export const onAuthChange = (callback: (user: User | null) => void) => {
  return onAuthStateChanged(auth, callback);
};

export default auth;
